export enum ConfigType {
  JurisdictionPriceSheet = 'JURISDICTION_PRICE_SHEET',
  LinguisticPriceSheet = 'LINGUISTIC_PRICE_SHEET',
  RenewalsPriceSheet = 'RENEWAL_PRICE_SHEET',
  RecodalsPriceSheet = 'RECORDAL_PRICE_SHEET',
  RecordalProjectLevelFlag = 'RECORDAL_PROJECT_LEVEL_FLAG',
  CompanyTmPreferences = 'COMPANY_TM_PREFERENCES',
}
